export default {
      id: "check-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#check",
      toString: function () {
        return this.url;
      }
    }